import type { App } from 'vue';

import useInjectScript from '@/composables/useInjectScript';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import { ref } from 'vue';

import {
  ChatSymbol,
  CHAT_URL_SDK,
  CHAT_URL_BASE,
  CHAT_WEBSITE_ID,
  CHAT_WEBSITE_TOKEN,
} from '@/configs/chat';

declare global {
  interface Window {
    $irfchat: Record<string, any>;
    irfchatSDK: Record<string, any>;
    irfchatSettings: Record<string, any>;
  }
}

export const api = {
  isReady: ref<boolean>(false),
  setReadyStatus(value: boolean) {
    this.isReady.value = value;
  },
  load: () => {
    window.irfchatSettings = {
      hideMessageBubble: true,
    };

    window.irfchatSDK.run({
      websiteToken: CHAT_WEBSITE_TOKEN,
      baseUrl: CHAT_URL_BASE,
    });
  },
  setUser: (name: string, nationalCode: string) => {
    const identifier = `1899 ${nationalCode}`;
    const identifier_hash: string = HmacSHA256(
      identifier,
      CHAT_WEBSITE_ID
    ).toString();

    window.addEventListener('irfchat:on-message', function () {
      window.$irfchat.setUser(identifier, {
        identifier_hash: identifier_hash,
        name: name,
      });
      window.$irfchat.setCustomAttributes({
        national_code: nationalCode,
      });
      window.$irfchat.setConversationCustomAttributes({
        chat_reason: '',
      });
    });
  },

  open: () => {
    window.$irfchat.toggle(true);
  },

  reset: () => {
    window.$irfchat.reset();
  },
};

const install = (app: App) => {
  useInjectScript(CHAT_URL_SDK).then(() => {
    api.setReadyStatus(true);
  });

  app.provide(ChatSymbol, api);
};

export { install };
